import { Fragment, useLayoutEffect, useRef } from 'react';
import { classes } from '../../utils/commonUtils';
import css from './loading.module.scss';

const animations = new Set<Animation>();

interface SpinnerProps {
  size?: number;
  fadeIn?: boolean;
  contained?: boolean;
  classNames?: {
    container?: string;
    spinner?: string;
  };
}

export default function Loading({ size = 48, fadeIn, contained, classNames }: SpinnerProps) {
  const Container = contained ? 'div' : Fragment;

  const ref = useRef<SVGPathElement>(null);

  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }

    const animation = node.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }], {
      duration: 750,
      iterations: Infinity,
    });

    animations.add(animation);

    if (animations.size > 0) {
      const firstAnimation = Array.from(animations)[0];
      animation.currentTime = firstAnimation.currentTime;
    }

    return () => {
      setTimeout(() => {
        animation.cancel();
        animations.delete(animation);
      }, 1000);
    };
  }, []);

  const props = contained
    ? {
        className: classes(css.container, classNames?.container),
        'data-fade': fadeIn,
      }
    : {};

  return (
    <Container {...props}>
      <svg
        className={classNames?.spinner}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25" />
        <path
          ref={ref}
          className={css.spinner}
          d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
        />
      </svg>
    </Container>
  );
}
